import { IPlanPhongHocTrongKyAsyncRequest } from "../../model/request/category/IPlanPhongHocTrongKyAsyncRequest";
import { IPlanPhongHocTrongKy } from "../../model/respone/category/IPlanPhongHocTrongKy";
import { apiClient } from "../apiClient";

export const PHONG_HOC_TRONG_KY_API = "phong-hoc-trong-ky";
export const phongHocTrongKyApi = {
    SelectAll: () => apiClient.get(`${PHONG_HOC_TRONG_KY_API}`),
    SelectByHocKyAndNamHoc: (hoc_ky: number, nam_hoc: string) => apiClient.get(`${PHONG_HOC_TRONG_KY_API}/hoc-ky/${hoc_ky}/nam-hoc/${nam_hoc}`),
    Async: (payload: IPlanPhongHocTrongKyAsyncRequest) => apiClient.post(`${PHONG_HOC_TRONG_KY_API}/sync`, payload),
    Update: (payload: IPlanPhongHocTrongKy) => apiClient.put(`${PHONG_HOC_TRONG_KY_API}`, payload),
};